import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('div', { 'className': 'row' }, React.createElement('embed', {
        'className': 'col-xs-12',
        'style': { minHeight: '90vh' },
        'src': 'https://app.gomotive.com/site_media/static/files/practitioner_terms_of_service.pdf',
        'type': 'application/pdf'
    }));
}